/* eslint class-methods-use-this: "off" */
import clamp from 'lodash.clamp';
import GridRange from "../GridRange.js";
import GridUtils from "../GridUtils.js";
import KeyHandler from "../KeyHandler.js";
class SelectionKeyHandler extends KeyHandler {
  onDown(event, grid) {
    switch (event.key) {
      case 'a':
        if (GridUtils.isModifierKeyDown(event)) {
          grid.selectAll();
          return true;
        }
        break;
      case 'ArrowUp':
        return this.handleArrowMove(0, -1, event, grid);
      case 'ArrowDown':
        return this.handleArrowMove(0, 1, event, grid);
      case 'ArrowRight':
        return this.handleArrowMove(1, 0, event, grid);
      case 'ArrowLeft':
        return this.handleArrowMove(-1, 0, event, grid);
      /**
       * h/j/k/l keys are grouped together for quick navigation by power users.
       * Bender added these as shortcuts in the original commit of keyboard shortcuts.
       * We have no idea why, or what might have inspired them (not excel, not swing, vim?).
       * Maybe lack of page up keys on a laptop at the time?
       */
      case 'k':
      case 'K':
        if (GridUtils.isModifierKeyDown(event)) return false;
        return this.handlePageUp(event, grid);
      case 'j':
      case 'J':
        if (GridUtils.isModifierKeyDown(event)) return false;
        return this.handlePageDown(event, grid);
      case 'h':
      case 'H':
        if (GridUtils.isModifierKeyDown(event)) return false;
        if (!event.shiftKey) {
          grid.clearSelectedRanges();
        }
        grid.moveCursorToPosition(0, grid.state.cursorRow, event.shiftKey);
        return true;
      case 'l':
      case 'L':
        {
          if (GridUtils.isModifierKeyDown(event)) return false;
          var model = grid.props.model;
          var columnCount = model.columnCount;
          if (!event.shiftKey) {
            grid.clearSelectedRanges();
          }
          grid.moveCursorToPosition(columnCount - 1, grid.state.cursorRow, event.shiftKey);
          return true;
        }
      case 'PageDown':
        return this.handlePageDown(event, grid);
      case 'PageUp':
        return this.handlePageUp(event, grid);
      case 'Home':
        if (!event.shiftKey) {
          grid.clearSelectedRanges();
        }
        grid.moveCursorToPosition(GridUtils.isModifierKeyDown(event) ? grid.state.cursorColumn : 0, GridUtils.isModifierKeyDown(event) ? 0 : grid.state.cursorRow, event.shiftKey, true, true);
        return true;
      case 'End':
        {
          var _model = grid.props.model;
          var _columnCount = _model.columnCount,
            rowCount = _model.rowCount;
          if (!event.shiftKey) {
            grid.clearSelectedRanges();
          }
          grid.moveCursorToPosition(GridUtils.isModifierKeyDown(event) ? grid.state.cursorColumn : _columnCount - 1, GridUtils.isModifierKeyDown(event) ? rowCount - 1 : grid.state.cursorRow, event.shiftKey, true, true);
          return true;
        }
      case 'Escape':
        if (grid.state.selectedRanges.length === 0) return false;
        grid.clearSelectedRanges();
        // consume the event, and stop propagation only if there were selected ranges to clear
        return {
          preventDefault: false,
          stopPropagation: true
        };
      case 'Enter':
        if (grid.state.selectedRanges.length > 0) {
          grid.moveCursorInDirection(event.shiftKey ? GridRange.SELECTION_DIRECTION.UP : GridRange.SELECTION_DIRECTION.DOWN);
          return true;
        }
        break;
      case 'Tab':
        if (grid.state.selectedRanges.length > 0) {
          grid.moveCursorInDirection(event.shiftKey ? GridRange.SELECTION_DIRECTION.LEFT : GridRange.SELECTION_DIRECTION.RIGHT);
          return true;
        }
        break;
      default:
        break;
    }
    return false;
  }
  handleArrowMove(deltaColumn, deltaRow, event, grid) {
    var isShiftKey = event.shiftKey;
    var isModifierKey = GridUtils.isModifierKeyDown(event);
    if (isShiftKey) {
      grid.trimSelectedRanges();
    } else {
      grid.clearSelectedRanges();
    }
    var _grid$state = grid.state,
      cursorRow = _grid$state.cursorRow,
      cursorColumn = _grid$state.cursorColumn,
      selectionEndColumn = _grid$state.selectionEndColumn,
      selectionEndRow = _grid$state.selectionEndRow;
    var column = isShiftKey ? selectionEndColumn : cursorColumn;
    var row = isShiftKey ? selectionEndRow : cursorRow;
    if (isModifierKey) {
      var model = grid.props.model;
      var columnCount = model.columnCount,
        rowCount = model.rowCount;
      var maximizePreviousRange = isModifierKey && isShiftKey;
      var moveToColumn = null;
      var moveToRow = null;
      if (deltaColumn < 0) {
        moveToColumn = 0;
        moveToRow = row;
      } else if (deltaColumn > 0) {
        moveToColumn = columnCount - 1;
        moveToRow = row;
      } else if (deltaRow < 0) {
        moveToColumn = column;
        moveToRow = 0;
      } else if (deltaRow > 0) {
        moveToColumn = column;
        moveToRow = rowCount - 1;
      }
      if (moveToColumn != null && moveToRow != null) {
        grid.moveCursorToPosition(moveToColumn, moveToRow, isShiftKey, true, maximizePreviousRange);
      }
    } else {
      if (!grid.metrics) throw new Error('grid.metrics are not set');
      var theme = grid.props.theme;
      var _theme$autoSelectRow = theme.autoSelectRow,
        autoSelectRow = _theme$autoSelectRow === void 0 ? false : _theme$autoSelectRow,
        _theme$autoSelectColu = theme.autoSelectColumn,
        autoSelectColumn = _theme$autoSelectColu === void 0 ? false : _theme$autoSelectColu;
      if (autoSelectRow && deltaColumn !== 0) {
        var lastLeft = grid.metrics.lastLeft;
        var left = grid.state.left;
        left = clamp(left + deltaColumn, 0, lastLeft);
        grid.moveCursorToPosition(left, cursorRow, isShiftKey, false);
        grid.setViewState({
          left
        });
      } else if (autoSelectColumn && deltaRow !== 0) {
        var lastTop = grid.metrics.lastTop;
        var top = grid.state.top;
        top = clamp(top + deltaRow, 0, lastTop);
        grid.moveCursorToPosition(top, cursorColumn, isShiftKey, false);
        grid.setViewState({
          top
        });
      } else {
        grid.moveCursor(deltaColumn, deltaRow, isShiftKey);
      }
    }
    return true;
  }
  handlePageUp(e, grid) {
    var isShiftKey = e.shiftKey;
    if (isShiftKey) {
      grid.trimSelectedRanges();
    } else {
      grid.clearSelectedRanges();
    }
    var _grid$state2 = grid.state,
      cursorColumn = _grid$state2.cursorColumn,
      selectionEndRow = _grid$state2.selectionEndRow;
    var row = selectionEndRow;
    var column = cursorColumn;
    if (row == null) {
      return false;
    }
    var metricState = grid.getMetricState();
    var metricCalculator = grid.metricCalculator;
    var _metricCalculator$get = metricCalculator.getMetrics(metricState),
      bottomVisible = _metricCalculator$get.bottomVisible,
      topVisible = _metricCalculator$get.topVisible,
      hasHorizontalBar = _metricCalculator$get.hasHorizontalBar;
    var selectRangeEndPosition = row - (bottomVisible - topVisible);
    selectRangeEndPosition -= hasHorizontalBar ? 0 : 1;

    // Don't move beyond the top table row.
    selectRangeEndPosition = Math.max(selectRangeEndPosition, 0);
    var viewportPosition = Math.max(selectRangeEndPosition - (row - topVisible), 0);
    grid.moveCursorToPosition(column, selectRangeEndPosition, isShiftKey, false);
    grid.setViewState({
      top: viewportPosition
    });
    return true;
  }
  handlePageDown(e, grid) {
    var isShiftKey = e.shiftKey;
    if (isShiftKey) {
      grid.trimSelectedRanges();
    } else {
      grid.clearSelectedRanges();
    }
    var _grid$state3 = grid.state,
      selectionEndRow = _grid$state3.selectionEndRow,
      cursorColumn = _grid$state3.cursorColumn;
    var row = selectionEndRow;
    var column = cursorColumn;
    if (row === null) {
      return false;
    }
    var metricState = grid.getMetricState();
    var metricCalculator = grid.metricCalculator;
    var _metricCalculator$get2 = metricCalculator.getMetrics(metricState),
      bottomVisible = _metricCalculator$get2.bottomVisible,
      topVisible = _metricCalculator$get2.topVisible,
      hasHorizontalBar = _metricCalculator$get2.hasHorizontalBar,
      rowCount = _metricCalculator$get2.rowCount,
      lastTop = _metricCalculator$get2.lastTop;
    var lastRowIndex = rowCount - 1;
    var selectRangeEndPosition = bottomVisible - topVisible + row;
    selectRangeEndPosition += hasHorizontalBar ? 0 : 1;

    // Don't move beyond the bottom table row.
    selectRangeEndPosition = Math.min(selectRangeEndPosition, lastRowIndex);
    var viewportPosition = Math.min(lastTop, selectRangeEndPosition - (row - topVisible));
    grid.moveCursorToPosition(column, selectRangeEndPosition, isShiftKey, false);
    grid.setViewState({
      top: viewportPosition
    });
    return true;
  }
}
export default SelectionKeyHandler;
//# sourceMappingURL=SelectionKeyHandler.js.map